/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Maturity_AcInputs */

const en_cad_compare_row_maturity_ac = /** @type {(inputs: Cad_Compare_Row_Maturity_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decades of production use, official support`)
};

/**
* | output |
* | --- |
* | "Decades of production use, official support" |
*
* @param {Cad_Compare_Row_Maturity_AcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_maturity_ac = /** @type {((inputs?: Cad_Compare_Row_Maturity_AcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Maturity_AcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_maturity_ac(inputs)
});
export { cad_compare_row_maturity_ac as "cad.compare.row_maturity_ac" }